import React, { useEffect, useState } from "react";
import "./PaymentMethod.scss";
import "react-credit-cards/es/styles-compiled.css";
import Card from "../Card/Card";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Modal, Skeleton } from "antd";
import debit from "@assets/icons/debit.svg";
import apple from "@assets/icons/apple.svg";
import google from "@assets/icons/google.png";
//import paypal from "@assets/icons/paypal.svg";
//import paypalRec from "@assets/icons/paypalRec.svg";
import visa from "@assets/icons/visa.svg";
import mastercard from "@assets/icons/mastercard.svg";
import amex from "@assets/icons/american-express.svg";
import { errorLog } from "logging";
import Helpers from "@utils/Helpers";
import { paymentApi } from "services/PaymentApi";

interface IPaymentMethod {
  isUpdating: boolean;
  setIsUpdating: (isUpdating: boolean) => void;
}

const cardIcons: Record<string, string> = {
  visa: visa,
  mastercard: mastercard,
  //paypal: paypalRec,
  amex: amex,
};

const PaymentMethod: React.FC<IPaymentMethod> = ({
  isUpdating,
  setIsUpdating,
}) => {
  const [isAddCard, setIsAddCard] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const emailPaypal = urlParams.get("email");
  const [allPayment, setAllPayment] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  // const SCOPE = "openid email profile";
  // const PAYPAL_URL = `${process.env.REACT_APP_PAYPAL_URL}?client_id=${
  //   process.env.REACT_APP_PAYPAL_ID
  // }&response_type=code&scope=${SCOPE}&redirect_uri=${
  //   process.env.REACT_APP_PAYPAL_REDIRECT_URI || ""
  // }`;

  useEffect(() => {
    const getAllPayment = async () => {
      try {
        const response = await paymentApi.getAllPayment();
        if (response.status === 200) {
          setAllPayment(response.data.data);
        }
      } catch (error) {
        setIsLoading(false);
        errorLog("PaymentMethod.tsx - getAllPayment", error);
      } finally {
        setIsLoading(false);
      }
    };
    if (!allPayment) {
      setIsLoading(true);
      getAllPayment();
    }
  }, [allPayment]);

  // const handlePaypal = () => {
  //   window.location.href = PAYPAL_URL;
  // };

  // useEffect(() => {
  //   const createPaypalMethod = async () => {
  //     try {
  //       const response = await paymentApi.createPaypalPayment({
  //         email: emailPaypal,
  //         is_default: false,
  //       });
  //       if (response.status === 200) {
  //         const baseUrl = window.location.origin;
  //         window.location.href = baseUrl + "/profile?direct=payment";
  //       }
  //     } catch (error) {
  //       Helpers.notification.error("Can not create method. Please try again");
  //       errorLog("PaymentMethod.tsx - createPaypalMethod", error);
  //     }
  //   };
  //   if (emailPaypal) {
  //     createPaypalMethod();
  //   }
  // }, [emailPaypal]);

  const handleSetDefault = async (paymentInfoId: any) => {
    setIsUpdating(true);
    try {
      const response = await paymentApi.updateDefaultPayment({
        payment_info_id: paymentInfoId,
        is_default: true,
      });
      if (response.status === 200) {
        setIsUpdating(false);
        const newPayment = allPayment.map((item: any) => {
          if (item.payment_info_id === paymentInfoId) {
            return { ...item, is_default: true };
          } else {
            return { ...item, is_default: false };
          }
        });
        newPayment.sort((a: any, b: any) => {
          if (a.is_default && !b.is_default) return -1;
          if (!a.is_default && b.is_default) return 1;
          return 0;
        });
        setAllPayment(newPayment);
        Helpers.showSuccessUpdated("Set default card successfully");
      }
    } catch (error) {
      setIsUpdating(false);
      Helpers.notification.error("Can not set card default. Please try again");
      errorLog("PaymentMethod.tsx - handleSetDefault", error);
    }
  };

  const handleDeleteCard = async (paymentInfoId: any) => {
    setIsUpdating(true);
    setIsOpenModal(false);
    try {
      const response = await paymentApi.deletePayment({
        payment_info_id: paymentInfoId,
      });
      if (response.status === 200) {
        setIsUpdating(false);
        const newPayment = allPayment.filter(
          (item: any) => item.payment_info_id !== paymentInfoId
        );
        setAllPayment(newPayment);
        Helpers.showSuccessUpdated("Delete card successfully");
      }
    } catch (error) {
      setIsUpdating(false);
      Helpers.notification.error("Can not delete card. Please try again");
      errorLog("PaymentMethod.tsx - handleDeleteCard", error);
    }
  };

  return (
    <>
      {isAddCard ? (
        <Card isUpdating={isUpdating} setIsUpdating={setIsUpdating} />
      ) : (
        <div className="PaymentMethod">
          {!isLoading ? (
            allPayment?.length > 0 ? (
              <div className="section">
                <div className="new-payment-group">
                  <Button
                    className="new-payment-item"
                    onClick={() => setIsAddCard(true)}
                    icon={<PlusOutlined />}
                  >
                    <div className="item-title">
                      <img src={debit} alt="debit-icon" width={20} />{" "}
                      Credit/Debit Card
                    </div>
                  </Button>
                </div>

                {allPayment.map((item: any, index: number) => {
                  return (
                    <div className="card-group" key={index}>
                      <div
                        className={`card-item ${
                          item?.is_default ? "active" : ""
                        }`}
                      >
                        <div className="card-content">
                          <div className="item-icon">
                            <img
                              src={
                                cardIcons[
                                  item.payment_type === "paypal"
                                    ? item.payment_type
                                    : item?.card_type
                                ] ?? debit
                              }
                              alt={`${item?.card_type}`}
                              width={60}
                            />
                          </div>
                          <div className="card-info">
                            {Helpers.hideCardNumber(item?.card_number ?? "")}
                            <span>Expires {item?.expiration_date}</span>
                          </div>
                          <div className="action-group">
                            {item?.is_default ? (
                              <Button className="default">Default</Button>
                            ) : (
                              <Button
                                className="default"
                                onClick={() =>
                                  handleSetDefault(item.payment_info_id)
                                }
                              >
                                Set as Default
                              </Button>
                            )}
                            <Button
                              className="action-item"
                              onClick={() => {
                                setIsOpenModal(true);
                              }}
                            >
                              <DeleteOutlined />
                            </Button>
                            <Modal
                              title="Confirm"
                              open={isOpenModal}
                              onOk={() =>
                                handleDeleteCard(item.payment_info_id)
                              }
                              className="confirm-popup"
                              onCancel={() => setIsOpenModal(false)}
                              okText="Delete"
                              cancelButtonProps={{ type: "text" }}
                            >
                              <p>
                                Once you delete your card, this action cannot be
                                reversed. Are you sure to continue?
                              </p>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="section">
                <div className="section-item">
                  <div className="section-title">
                    You have no save credit or debit cards.
                  </div>
                </div>
                <div className="section-item">
                  <div className="section-title">New payment method</div>
                  <div className="payment-methods">
                    <Button
                      className="payment-methods-item"
                      onClick={() => setIsAddCard(true)}
                    >
                      <div className="item-icon">
                        <PlusOutlined />
                      </div>
                      <div className="item-title">
                        <img src={debit} alt="debit-icon" width={20} />{" "}
                        Credit/Debit Card
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )
          ) : (
            Array.from({ length: 3 }).map((item, index) => {
              return (
                <div className="payment-skeleton" key={index}>
                  <Skeleton active />
                </div>
              );
            })
          )}
        </div>
      )}
    </>
  );
};

export default PaymentMethod;
